module.exports = {
    config: require('./config'),
    version: require('./version'),
    procedures: {
        app_create: {
            definition: require('./app_create/definition.json'),
            mock_data: require('./app_create/mock_data.json')
        },
        app_list: {
            definition: require('./app_list/definition.json'),
            mock_data: require('./app_list/mock_data.json')
        },
        app_module_create: {
            definition: require('./app_module_create/definition.json'),
            mock_data: require('./app_module_create/mock_data.json')
        },
        app_module_list: {
            definition: require('./app_module_list/definition.json'),
            mock_data: require('./app_module_list/mock_data.json')
        },
        app_module_update: {
            definition: require('./app_module_update/definition.json'),
            mock_data: require('./app_module_update/mock_data.json')
        },
        app_plan_create: {
            definition: require('./app_plan_create/definition.json'),
            mock_data: require('./app_plan_create/mock_data.json')
        },
        app_plan_list: {
            definition: require('./app_plan_list/definition.json'),
            mock_data: require('./app_plan_list/mock_data.json')
        },
        app_plan_permission_create: {
            definition: require('./app_plan_permission_create/definition.json'),
            mock_data: require('./app_plan_permission_create/mock_data.json')
        },
        app_plan_permission_list: {
            definition: require('./app_plan_permission_list/definition.json'),
            mock_data: require('./app_plan_permission_list/mock_data.json')
        },
        app_plan_permission_update: {
            definition: require('./app_plan_permission_update/definition.json'),
            mock_data: require('./app_plan_permission_update/mock_data.json')
        },
        app_plan_update: {
            definition: require('./app_plan_update/definition.json'),
            mock_data: require('./app_plan_update/mock_data.json')
        },
        app_role_create: {
            definition: require('./app_role_create/definition.json'),
            mock_data: require('./app_role_create/mock_data.json')
        },
        app_role_list: {
            definition: require('./app_role_list/definition.json'),
            mock_data: require('./app_role_list/mock_data.json')
        },
        app_role_permission_create: {
            definition: require('./app_role_permission_create/definition.json'),
            mock_data: require('./app_role_permission_create/mock_data.json')
        },
        app_role_permission_list: {
            definition: require('./app_role_permission_list/definition.json'),
            mock_data: require('./app_role_permission_list/mock_data.json')
        },
        app_role_permission_update: {
            definition: require('./app_role_permission_update/definition.json'),
            mock_data: require('./app_role_permission_update/mock_data.json')
        },
        app_role_update: {
            definition: require('./app_role_update/definition.json'),
            mock_data: require('./app_role_update/mock_data.json')
        },
        campaign_app_create: {
            definition: require('./campaign_app_create/definition.json'),
            mock_data: require('./campaign_app_create/mock_data.json')
        },
        campaign_app_read: {
            definition: require('./campaign_app_read/definition.json'),
            mock_data: require('./campaign_app_read/mock_data.json')
        },
        campaign_app_update: {
            definition: require('./campaign_app_update/definition.json'),
            mock_data: require('./campaign_app_update/mock_data.json')
        },
        campaign_create: {
            definition: require('./campaign_create/definition.json'),
            mock_data: require('./campaign_create/mock_data.json')
        },
        campaign_list: {
            definition: require('./campaign_list/definition.json'),
            mock_data: require('./campaign_list/mock_data.json')
        },
        campaign_type_list: {
            definition: require('./campaign_type_list/definition.json'),
            mock_data: require('./campaign_type_list/mock_data.json')
        },
        campaign_read: {
            definition: require('./campaign_read/definition.json'),
            mock_data: require('./campaign_read/mock_data.json')
        },
        campaign_update: {
            definition: require('./campaign_update/definition.json'),
            mock_data: require('./campaign_update/mock_data.json')
        },
        campaign_user_app_role_update: {
            definition: require('./campaign_user_app_role_update/definition.json'),
            mock_data: require('./campaign_user_app_role_update/mock_data.json')
        },
        campaign_user_role_upsert: {
            definition: require('./campaign_user_role_upsert/definition.json'),
            mock_data: require('./campaign_user_role_upsert/mock_data.json')
        },
        campaign_user_join_create: {
            definition: require('./campaign_user_join_create/definition.json'),
            mock_data: require('./campaign_user_join_create/mock_data.json')
        },
        campaign_user_join_list: {
            definition: require('./campaign_user_join_list/definition.json'),
            mock_data: require('./campaign_user_join_list/mock_data.json')
        },
        campaign_user_join_update: {
            definition: require('./campaign_user_join_update/definition.json'),
            mock_data: require('./campaign_user_join_update/mock_data.json')
        },
        campaign_user_list: {
            definition: require('./campaign_user_list/definition.json'),
            mock_data: require('./campaign_user_list/mock_data.json')
        },
        campaign_user_update: {
            definition: require('./campaign_user_update/definition.json'),
            mock_data: require('./campaign_user_update/mock_data.json')
        },
        campaign_user_role_list: {
            definition: require('./campaign_user_role_list/definition.json'),
            mock_data: require('./campaign_user_role_list/mock_data.json')
        },
        campaign_mode_list: {
            definition: require('./campaign_mode_list/definition.json'),
            mock_data: require('./campaign_mode_list/mock_data.json')
        },
        campaign_mode_create: {
            definition: require('./campaign_mode_create/definition.json'),
            mock_data: require('./campaign_mode_create/mock_data.json')
        },
        permission_create: {
            definition: require('./permission_create/definition.json'),
            mock_data: require('./permission_create/mock_data.json')
        },
        permission_list: {
            definition: require('./permission_list/definition.json'),
            mock_data: require('./permission_list/mock_data.json')
        },
        permission_update: {
            definition: require('./permission_update/definition.json'),
            mock_data: require('./permission_update/mock_data.json')
        },
        recovery_password: {
            definition: require('./recovery_password/definition.json'),
            mock_data: require('./recovery_password/mock_data.json')
        },
        user_create: {
            definition: require('./user_create/definition.json'),
            mock_data: require('./user_create/mock_data.json')
        },
        user_list: {
            definition: require('./user_list/definition.json'),
            mock_data: require('./user_list/mock_data.json')
        },
        user_read: {
            definition: require('./user_read/definition.json'),
            mock_data: require('./user_read/mock_data.json')
        },
        user_update: {
            definition: require('./user_update/definition.json'),
            mock_data: require('./user_update/mock_data.json')
        },
        user_auth: {
            definition: require('./user_auth/definition.json'),
            mock_data: require('./user_auth/mock_data.json')
        },
        user_update_password: {
            definition: require('./user_password_update/definition.json'),
            mock_data: require('./user_password_update/mock_data.json')
        },
        user_recovery_create: {
            definition: require('./user_recovery_create/definition.json'),
            mock_data: require('./user_recovery_create/mock_data.json')
        },
        app_user_device_notification_subscription_create: {
            definition: require('./app_user_device_notification_subscription_create/definition.json'),
            mock_data: require('./app_user_device_notification_subscription_create/mock_data.json')
        },
        app_user_device_notification_subscription_list: {
            definition: require('./app_user_device_notification_subscription_list/definition.json'),
            mock_data: require('./app_user_device_notification_subscription_list/mock_data.json')
        },
        app_user_device_notification_subscription_delete: {
            definition: require('./app_user_device_notification_subscription_delete/definition.json'),
            mock_data: require('./app_user_device_notification_subscription_delete/mock_data.json')
        },
        user_current_data_read: {
            definition: require('./user_current_data_read/definition.json'),
            mock_data: require('./user_current_data_read/mock_data.json')
        },
        data_provider_mode_create: {
            definition: require('./data_provider_mode_create/definition.json'),
            mock_data: require('./data_provider_mode_create/mock_data.json')
        },
        data_provider_mode_list: {
            definition: require('./data_provider_mode_list/definition.json'),
            mock_data: require('./data_provider_mode_list/mock_data.json')
        },
        data_provider_mode_read: {
            definition: require('./data_provider_mode_read/definition.json'),
            mock_data: require('./data_provider_mode_read/mock_data.json')
        },
        data_provider_mode_update: {
            definition: require('./data_provider_mode_update/definition.json'),
            mock_data: require('./data_provider_mode_update/mock_data.json')
        },
        role_list: {
            definition: require('./role_list/definition.json'),
            mock_data: require('./role_list/mock_data.json')
        },
        role_create: {
            definition: require('./role_create/definition.json'),
            mock_data: require('./role_create/mock_data.json')
        },
        role_update: {
            definition: require('./role_update/definition.json'),
            mock_data: require('./role_update/mock_data.json')
        },
        permission_group_permission_model_list: {
            definition: require('./permission_group_permission_model_list/definition.json'),
            mock_data: require('./permission_group_permission_model_list/mock_data.json')
        },
        permission_group_create:{
            definition: require('./permission_group_create/definition.json'),
            mock_data: require('./permission_group_create/mock_data.json')
        },
        permission_group_update:{
            definition: require('./permission_group_update/definition.json'),
            mock_data: require('./permission_group_update/mock_data.json')
        },
        permission_group_list:{
            definition: require('./permission_group_list/definition.json'),
            mock_data: require('./permission_group_list/mock_data.json')
        },
        permission_group_permission_create:{
            definition: require('./permission_group_permission_create/definition.json'),
            mock_data: require('./permission_group_permission_create/mock_data.json')
        },
        permission_group_permission_delete:{
            definition: require('./permission_group_permission_delete/definition.json'),
            mock_data: require('./permission_group_permission_delete/mock_data.json')
        },
        permission_group_permission_update:{
            definition: require('./permission_group_permission_update/definition.json'),
            mock_data: require('./permission_group_permission_update/mock_data.json')
        },
        permission_group_permission_list:{
            definition: require('./permission_group_permission_list/definition.json'),
            mock_data: require('./permission_group_permission_list/mock_data.json')
        },
        permission_group_and_permission_list:{
            definition: require('./permission_group_and_permission_list/definition.json'),
            mock_data: require('./permission_group_and_permission_list/mock_data.json')
        },
        role_and_permission_group_list:{
            definition: require('./role_and_permission_group_list/definition.json'),
            mock_data: require('./role_and_permission_group_list/mock_data.json')
        },
        role_permission_group_create:{
            definition: require('./role_permission_group_create/definition.json'),
            mock_data: require('./role_permission_group_create/mock_data.json')
        },
        role_permission_group_delete:{
            definition: require('./role_permission_group_delete/definition.json'),
            mock_data: require('./role_permission_group_delete/mock_data.json')
        },
        app_plan_permission_group_create:{
            definition: require('./app_plan_permission_group_create/definition.json'),
            mock_data: require('./app_plan_permission_group_create/mock_data.json')
        },
        app_plan_permission_group_delete:{
            definition: require('./app_plan_permission_group_delete/definition.json'),
            mock_data: require('./app_plan_permission_group_delete/mock_data.json')
        },
        app_plan_and_permission_group_list:{
            definition: require('./app_plan_and_permission_group_list/definition.json'),
            mock_data: require('./app_plan_and_permission_group_list/mock_data.json')
        }
    }
};